<template>
    <div class="parametric">
        <div class="parametric__top">
            <div class="parametric__top-title">
                <h1>Недвижимость</h1>
            </div>
        </div>

        <div v-if="categories?.length"
             class="parametric__tabs">
            <STTabs :list="categories"
                    @click="changeTabProject" />
        </div>

        <STDivider />

        <div class="transition-block"
             :style="{ opacity: animationOpacity, display: animationDisplay}">
            <ParametricComplexes
                v-if="complexes?.length"
                :projects="complexes" />
            <ParametricFilters v-if="viewFilters"
                               :filters="viewFilters"
                               @onChangeFilters="onChangeFilters" />

            <ParametricSort v-if="viewPremises?.length"
                            :items="currentSortItems"
                            :current-sort-type="currentSortType"
                            @onChangeSort="setSort"
                            @onEndChangeSort="onEndChangeSort" />

            <div v-if="viewPremises?.length"
                 class="parametric__info-text">
                Цены не являются публичной офертой и представлены только для ознакомления.
            </div>

            <div id="parametric-content"
                 class="parametric__content">
                <ParametricFlats v-if="viewPremises?.length"
                                 :flats="viewPremises"
                                 :is-mobile="isMobile" />

                <ParametricPagination v-if="viewPagination"
                                      :current-page="viewPagination?.current || 1"
                                      :last-page="viewPagination?.all || 1"
                                      @onChangePage="onChangePage" />

                <STLoader :loading="isProcessing"
                          modify="loader_full_size loader_theme_white" />
            </div>
        </div>

        <ParametricLimit />

        <TheSidebar ref="sidebar"
                    :is-custom-button-text="true"
                    :button-text="printFlatsIds.length ? `Выбрано ${printFlatsIds.length}` : ''"
                    :hide-default-content="true"
                    :hide-sidebar-news="true">
            <ParametricSidebar @showSendPopup="showSendPopup" />
        </TheSidebar>

        <STPopup ref="popupForPdf"
                 :icon-close-big="false"
                 modify="popup_middle_size popup_center_position">
            <ParametricSend :type="typePdfSend"
                            :flats="printFlatsIds"
                            @closePopup="closeSendPopup" />
        </STPopup>
    </div>
</template>

<script>
import ParametricComplexes from '@/blocks/ParametricBlock/ParametricProjectsList/ParametricProjectsList.vue';
import ParametricFilters from '@/blocks/ParametricBlock/ParametricFilters/ParametricFilters';
import ParametricFlats from '@/blocks/ParametricBlock/ParametricFlats/ParametricFlats';
import ParametricLimit from '@/blocks/ParametricBlock/ParametricLimit/ParametricLimit';
import ParametricPagination from '@/blocks/ParametricBlock/ParametricPagination/ParametricPagination';
import ParametricSend from '@/blocks/ParametricBlock/ParametricSend/ParametricSend';
import ParametricSidebar from '@/blocks/ParametricBlock/ParametricSidebar/ParametricSidebar';
import ParametricSort from '@/blocks/ParametricBlock/ParametricSort/ParametricSort';
import TheSidebar from '@/sections/TheSidebar/TheSidebar';
import {mapActions, mapGetters} from 'vuex';
import Utils from '@/helpers/Utils';

export default {
    name: 'Parametric',

    components: {
        ParametricComplexes,
        ParametricFilters,
        ParametricFlats,
        ParametricLimit,
        ParametricPagination,
        ParametricSend,
        ParametricSidebar,
        ParametricSort,
        TheSidebar
    },

    data() {
        return {
            complexes       : [],        // массив комплексов
            viewFilters     : null,      // показываемые фильтры
            viewPremises    : [],        // показываемые помещения
            viewPagination  : null,      // показываемая пагинация
            typePdfSend     : null,      // тип формирования pdf, для почты email, для скачивания download
            currentSortItems: {},        // показываемая сортировка
            currentSortType : {},        // тип показываемой сортировки
            animationOpacity: '1',       // анимация - время перехода
            animationDisplay: 'block',   // анимация - тип отображения
            windowWidth     : Utils.getWindowWidth(), // ширина окна браузера
        };
    },

    computed: {
        ...mapGetters({
            categories   : 'parametric/GET_CATEGORIES',      // массив категорий
            premises     : 'parametric/GET_PREMISES',        // объект помещений
            printFlats   : 'parametric/GET_PRINT_FLATS',     // массив помещений для печати
            printFlatsIds: 'parametric/GET_PRINT_FLATS_IDS', // массив id-шников помещений для печати
            activeType   : 'parametric/GET_ACTIVE_TYPE',     // тип показываемых помещений
            isProcessing : 'parametric/GET_IS_PROCESSING',   // происходит ли сейчас подгрузка
            pagination   : 'parametric/GET_PAGINATION',      // объект пагинации
            filters      : 'parametric/GET_FILTERS',         // объект фильтров
            sortCurrent  : 'parametric/GET_CURRENT_SORT',    // текущая сотрировка
            sortItems    : 'parametric/GET_SORT_ITEMS',      // доступные сортировки
        }),
        ...mapGetters({
            projects: 'GET_PROJECTS'
        }),

        isMobile() {
            return this.windowWidth < 1024;
        },

        computedProjects() {
            return this.projects;
        }
    },

    async mounted() {
        if (!this.projects?.length) {
            await this.$store.dispatch('getProjectsInfo');
        }

        const urlQuery = this.$route.query;
        const filterKeys = Object.keys(urlQuery).filter(k => k !== 'test');
        const hasUrlFilters = filterKeys.length > 0;
        const category = urlQuery.category || 'flats';

        const body = {
            type: 'init',
            category,
        };

        if (hasUrlFilters) {
            const presetParams = {};

            filterKeys
                .filter(k => k !== 'category')
                .forEach(k => { presetParams[k] = urlQuery[k]; });

            if (Object.keys(presetParams).length) {
                body.presetParams = presetParams;
            }
        }

        // Инициализируем данные
        this.init(body)
            .then(() => {
                // Устанавливаем показываемые помещения, фильтры, пагинацию, сортировку
                this.setViewPremises();
                this.setFilters();
                this.setPagination();
                this.setSort();
                this.setComplexes();
            });


        window.addEventListener('resize', this.handleWindowSizeChange);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
        this.$store.commit('parametric/SET_FORM', null);
    },

    methods: {
        ...mapActions('parametric', ['init', 'initCategory']),

        /**
         * Метод смены таба
         * @param {String} id - id таба
         */
        changeTabProject(id) {
            const body = {
                type    : 'init',
                category: id,
                clear   : true
            };

            // Сбрасываем GET-параметры фильтров при смене таба
            this.$router.replace({ query: {} }).catch(() => {});

            // Инициализируем новую категорию
            this.initCategory(body)
                .then(() => {
                    // Запускаем анимацию и устанавливаем новые данные на странице
                    this.startAnimationFade();
                    this.setViewPremises();
                    this.setFilters();
                    this.setPagination();
                    this.setSort();
                    this.setComplexes();
                });
        },

        /**
         * Открывает попап для отправки пдф
         * @param {String} type - тип формирования pdf, для почты email, для скачивания download
         */
        showSendPopup(type) {
            this.typePdfSend = type;

            this.$refs.popupForPdf.open();
        },

        /**
         * Закрывает попап для формирования пдф
         */
        closeSendPopup() {
            this.$refs.popupForPdf.close();
        },

        /**
         * Событие при смене страницы в пагинации
         */
        onChangePage() {
            // Устанавливаем новые данные на странице
            this.setViewPremises();
            this.setPagination();

            // Листаем страницу к началу
            this.$nextTick(() => {
                this.scrollTo('#parametric-content', -300);
            });
        },

        /**
         * Событие при смене фильтра
         */
        onChangeFilters() {
            // Устанавливаем новые данные на странице
            this.setViewPremises();
            this.setFilters();
            this.setPagination();
            this.syncFiltersToUrl();
        },

        /**
         * Событие при завершении смены сортировки
         */
        onEndChangeSort() {
            this.setViewPremises();
            this.syncFiltersToUrl();
        },

        /**
         * Синхронизирует текущие значения фильтров и сортировки с GET-параметрами URL
         */
        syncFiltersToUrl() {
            const formData = this.$store.getters['parametric/GET_FORM_DATA'];

            if (!formData) return;

            const skipKeys = new Set(['type', 'category', 'page']);
            const query = {};

            for (const [key, value] of formData.entries()) {
                if (skipKeys.has(key) || value === '' || value === null || value === undefined) continue;

                if (query[key] !== undefined) {
                    if (!Array.isArray(query[key])) {
                        query[key] = [query[key]];
                    }
                    query[key].push(value);
                } else {
                    query[key] = value;
                }
            }

            // После смены фильтра formData не содержит sort/order — берём из store
            if (!query.sort && !query.order) {
                const sortCurrent = this.sortCurrent[this.activeType];

                if (sortCurrent?.type) query.sort = sortCurrent.type;
                if (sortCurrent?.order) query.order = sortCurrent.order;
            }

            // Включаем категорию только если есть что сохранять
            if (Object.keys(query).length > 0 && this.activeType) {
                query.category = this.activeType;
            }

            this.$router.replace({ query }).catch(() => {});
        },

        /**
         * Устанавливает показываемые помещения
         * Берутся помещения из объектка помещений по активному типу (квартиры, офисы, коммерция)
         */
        setViewPremises() {
            if (!this.activeType || !this.premises || !(this.activeType in this.premises)) {
                this.viewPremises = [];
            }

            this.viewPremises = this.premises[this.activeType];
        },

        /**
         * Устанавливает показываемую пагинацию
         * Берётся пагинация из объектка пагинаций по активному типу (квартиры, офисы, коммерция)
         */
        setPagination() {
            if (!this.pagination || !this.activeType || !(this.activeType in this.pagination)) {
                this.viewPagination = null;
            }

            this.viewPagination = this.pagination[this.activeType];
        },

        /**
         * Устанавливает показываемые фильтры
         * Берутся фильтры из объектка фильтров по активному типу (квартиры, офисы, коммерция)
         */
        setFilters() {
            if (!this.filters || !this.activeType || !(this.activeType in this.filters)) {
                this.viewFilters = null;
            }

            this.viewFilters = this.filters[this.activeType];
        },

        /**
         * Устанавливает показываемые сортировку
         * Берётся сортировка из объектка сортировок по активному типу (квартиры, офисы, коммерция)
         */
        setSort() {
            if (!this.sortItems || !this.activeType || !(this.activeType in this.sortItems)) {
                this.currentSortItems = {};
            }

            // Устанавливает объект доступных сотрировок для текущего типа показываемых помещений
            this.currentSortItems = this.sortItems[this.activeType] || {};

            if (!this.sortCurrent || !this.activeType || !(this.activeType in this.sortCurrent)) {
                this.currentSortType = {};
            }

            // Устанавливает текущую сортировку для текущего типа показываемых помещений
            this.currentSortType = this.sortCurrent[this.activeType] || {};
        },

        setComplexes() {
            this.complexes = [];

            const activeComplexes = this.viewFilters.find(filter => filter.category === 'project').items.map(item => item.name);

            if (!activeComplexes || !activeComplexes.length) {
                return;
            }

            this.complexes = this.projects.filter(project => activeComplexes.includes(project.name));
        },

        /**
         * Скролит страница до якоря
         * @param id {string} - id блока на странице
         * @param offset {number} - отступ
         */
        scrollTo(id, offset = 0) {
            const block = document.querySelector(id);
            const top = block.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top     : top + offset,
                behavior: 'smooth',
            });
        },

        /**
         * Анимация перехода
         */
        startAnimationFade() {
            this.animationDisplay = 'none';
            this.animationOpacity = '0';

            setTimeout(() => {
                this.animationDisplay = 'block';
            }, 50);

            setTimeout(() => {
                this.animationOpacity = '1';
            }, 150);
        },

        handleWindowSizeChange() {
            this.windowWidth = Utils.getWindowWidth();
        },
    }
};
</script>

<style lang="scss">
@import "Parametric";
</style>
